import Button from '@cobliteam/colib-ui/Button';
import Icon from '@cobliteam/colib-ui/Icon';
import Typography from '@cobliteam/colib-ui/Typography';
import { Location } from '@cobliteam/common-types';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div className='flex h-full flex-col items-center justify-center gap-4 text-center'>
      <Icon name='message-square-x' size='4xl' className='box-content overflow-visible rounded-full bg-secondary p-10' />
      <Typography variant='headline' className='gap-1 break-words text-foreground' render={(props) => <h1 {...props} />}>
        404 Ops! Parece que essa página não existe
      </Typography>
      <Typography variant='body' className='gap-1 break-words text-foreground'>
        Talvez a gente tenha movido essa página ou pode haver algum erro na url.
      </Typography>
      <Link to={Location.HOME}>
        <Button>
          <Icon size='sm' name='house' />
          Voltar para a página inicial
        </Button>
      </Link>
    </div>
  );
};

export default NotFoundPage;
